import { Truck, Wrench, Tractor, Forklift, Container, Ship, Cog, HardHat } from "lucide-react";

// Íconos disponibles para tipos de unidad (ABM en /admin/tipos). El backend valida
// que "icono" sea una de estas claves (ver ICONOS_TIPO_VALIDOS en admin_routes.py).
export const TIPO_ICONOS = {
  truck: Truck,
  wrench: Wrench,
  tractor: Tractor,
  forklift: Forklift,
  container: Container,
  ship: Ship,
  cog: Cog,
  "hard-hat": HardHat,
};

export const TipoIcon = ({ icono, ...props }) => {
  const Comp = TIPO_ICONOS[icono] || Truck;
  return <Comp {...props} />;
};
